/**
 * Offline Module Entry Point
 * Exports all offline-related functionality
 */

// Core modules
import dbModule from './db';
import offlineManagerModule from './offlineManager';
import setupOfflineInterceptorModule, { isQueuedResponse, getTransactionId } from './axiosInterceptor';
import { useOfflineStatus, useOfflineStats } from './useOfflineStatus';
import SyncStatusIndicatorModule from './components/SyncStatusIndicator';
import useRefreshPreventionModule from './useRefreshPrevention';

// Re-export for named imports
export { default as db } from './db';
export { default as offlineManager } from './offlineManager';
export { default as setupOfflineInterceptor, isQueuedResponse, getTransactionId } from './axiosInterceptor';
export { useOfflineStatus, useOfflineStats } from './useOfflineStatus';
export { default as SyncStatusIndicator } from './components/SyncStatusIndicator';
export { default as useRefreshPrevention } from './useRefreshPrevention';

/**
 * Initialize offline support
 * Call this once in your app initialization
 */
export const initializeOfflineSupport = () => {
  console.log('🚀 Initializing offline support...');
  
  // Setup axios interceptor
  setupOfflineInterceptorModule();
  
  // Setup service worker listener for sync requests
  if ('serviceWorker' in navigator) {
    window.addEventListener('sw-sync-request', async () => {
      console.log('📡 Service worker requested sync');
      await offlineManagerModule.syncPendingTransactions();
    });
  }
  
  // Cleanup old cache on startup
  dbModule.clearOldCache(7).catch(err => {
    console.error('Error clearing old cache:', err);
  });
  
  // Expose debug functions globally for testing
  window.offlineDebug = {
    db: dbModule,
    clearAllTransactions: () => dbModule.clearAllPendingTransactions(),
    clearInvalidTransactions: () => dbModule.clearInvalidTransactions(),
    debugTransactions: () => dbModule.debugPendingTransactions(),
    manualSync: () => offlineManagerModule.manualSync(),
    getPendingCount: () => dbModule.getPendingCount()
  };
  console.log('🔧 Debug functions available at window.offlineDebug');
  
  console.log('✅ Offline support initialized');
};

// Default export
export default {
  db: dbModule,
  offlineManager: offlineManagerModule,
  setupOfflineInterceptor: setupOfflineInterceptorModule,
  useOfflineStatus,
  useOfflineStats,
  SyncStatusIndicator: SyncStatusIndicatorModule,
  useRefreshPrevention: useRefreshPreventionModule,
  initializeOfflineSupport
};
